import * as constants from '../constants';

const initialState = null;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.setUUID.toString(): {
            return action.payload;
        }

        default:
            return state;
    }
}
